import React, { Fragment, useState } from 'react'
import firebaseClient from '../firebase/FirebaseClient'

import OverlayText from '../components/OverlayText'
import SubmitButton from '../components/SubmitButton'
import Footer from '../components/Footer'

import './DataPrivacy.css'

const DataPrivacy = () => {
    
    const [formData, setFormData] = useState({
        email: '',
        requestType: '',
        additionalInfo: ''
    });
    
    //const [recaptchaToken, setRecaptchaToken] = useState(null);

    const [buttonText, setButtonText] = useState('Submit Request');
    const [isLoading, setIsLoading] = useState(false);
    const [isDone, setIsDone] = useState(false);
    const [contentText, setContentText] = useState("Processing...")
    const [statusMessage, setStatusMessage] = useState('');
    const [statusType, setStatusType] = useState('');
    
    const handleChange = (e) => {
        setFormData({
        ...formData,
        [e.target.name]: e.target.value
        });
    };
    
    // before sending the request, we require users to solve a puzzle
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        //if (!recaptchaToken) {
            //alert('Please complete the reCAPTCHA.');
        //    setStatusMessage('Please complete the reCAPTCHA.');
        //    setStatusType('error');
        //    return;
        if (!formData.email) {
            //alert('Please enter your email.');
            setStatusMessage('Please enter your email.');
            setStatusType('error');
            return;
        } else if (!formData.requestType) {
            //alert('Please choose a request type.');
            setStatusMessage('Please choose a request type.');
            setStatusType('error');
            return;
        }

        setIsLoading(true)

        console.log(`Form data - email: ${formData.email}`)
        console.log(`Form data - request type: ${formData.requestType}`)
        //console.log(`Form data - additional info: ${formData.additionalInfo}`)
        
        const { success, message } = 
            await firebaseClient.sendRequest(formData.email, formData.requestType, formData.additionalInfo);
        
        setIsLoading(false)
        setIsDone(true)

        if (success) {
            setButtonText("Done")
            setFormData({email: "", requestType: ""})
            setContentText("Request sent successfully")
            setStatusMessage("Request sent successfully, you will received a confirmation email.")
            setStatusType("success")
        } else {
            setButtonText("Failed")
            setStatusMessage(`Request not sent, ${message}`)
            setStatusType("error")
        }
    };

    const resetForm = () => {
        setFormData(
            { 
                email: "",
                requestType: "",
                additionalInfo: ""
            }
        )
        setContentText("")
        //setIsLoading(false)
        //setIsDone(false)
        setButtonText("Submit Request")
        setStatusMessage("")
        setStatusType("")
    }

    const resetStatus = () => {
        setStatusMessage("")
        setStatusType("")
    }
    
    return (
        <Fragment>
            <div className="data-privacy-page">
            {isLoading && <div className='data-privacy-overlay'><OverlayText content={contentText} /></div>}
                <div className="data-privacy-text-content">
                <div className="data-privacy-background-overlay"></div>
                    <form className="data-privacy-form" onSubmit={handleSubmit}>
                        
                        <div className='data-privacy-title'>
                            Request Data Deletion
                        </div>
                        
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            placeholder='Enter your email'
                        />
                        <div className="request-options">
                            <select
                                id="request"
                                name="requestType"
                                value={formData.requestType}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select a request type</option>
                                <option value="deleteAccount">Delete Account</option>
                                <option value="deleteData">Delete Data</option>
                                <option value="deleteBoth">Delete Both</option>
                            </select>
                        </div>
                        
                        <div className="additional-info">
                            
                            <textarea
                                id="additionalInfo"
                                name="additionalInfo"
                                value={formData.additionalInfo}
                                onChange={handleChange}
                                rows="4"
                                placeholder='Enter additional information (optional)'
                            />
                        </div>
                        
                        
                        <div className={`data-privacy-status-message ${statusType ? statusType : 'no-status'}`}>
                            {statusMessage &&  (
                                <>
                                    <span >{statusMessage}&nbsp;&nbsp;&nbsp;</span>
                                    <button 
                                        className='data-privacy-ok-button'
                                        onClick={ statusType == "success" ? resetForm : resetStatus }
                                        
                                    >OK</button>
                                </>
                            )}
                            </div>
                    
                        <SubmitButton isLoading={isLoading} isDone={isDone} buttonText={buttonText}/>
                    </form>
                
                </div>
                
            </div>
            <Footer />
        </Fragment>
    )
}

export default DataPrivacy;